export const MATCHING_CONFIG_STATE_ERROR = 'could not find matching config for state';
